module.exports = __webpack_public_path__ + "img/Airbnb-Landing-Page-On-the-Move.d2b32632.jpg";